import {createAnatomy} from '@zag-js/anatomy';

export const numbersAnatomy = createAnatomy(`numbers`).parts(`container`, `numbersContainer`, `label`, `right`, `left`);

export const parts = numbersAnatomy.build();

export type Part = keyof typeof parts;
